import { render, staticRenderFns } from "./CreateProgramPage.vue?vue&type=template&id=52b23c53&scoped=true&"
import script from "./CreateProgramPage.vue?vue&type=script&lang=js&"
export * from "./CreateProgramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b23c53",
  null
  
)

export default component.exports